import React from 'react';
import { Box } from '@chakra-ui/react';

const SecondarySection = props => {
  return <Box display={'flex'} flex={1} flexDirection={'column'} {...props} />;
};

export default SecondarySection;
